import styled from "styled-components"
import DotsMore from 'assets/creators/stat/dots-more.svg'

export const Container = styled.div`
  position: relative;
`

export const BtnStyled = styled.button`
  background-image: url(${DotsMore});
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 50%;

  border: none;
  background-color: ${({ theme, $isOpen }) => $isOpen
    ? theme.old.colors.gray[800]
    : theme.old.colors.transparent
  };
  
  width: 34px;
  height: 34px;
  cursor: pointer;

  transition: 200ms;
  
  :hover {
    background-color: ${({ theme }) => theme.old.colors.gray[800]}
  }
`

export const CardStyled = styled.div`
  position: fixed;

  border-radius: 6px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  background-color: ${({ theme }) => theme.old.colors.white};
  padding: 4px 0;
  z-index: 1;

  display: ${({ $isOpen }) => $isOpen ? 'flex' : 'none'};
  visibility: ${({ $isOpen }) => $isOpen ? 'visible' : 'hidden'};
  flex-direction: column;
  
  left: ${({ $xPosition }) => `${$xPosition}px`};
  top: ${({ $yPosition }) => `${$yPosition}px`};
`

export const OptionStyled = styled.div`
  white-space: nowrap;
  color: ${({ theme }) => theme.old.colors.gray[100]};
  font-weight: ${({ theme }) => theme.old.fonts.weight.medium};
  font-size: ${({ theme }) => theme.old.fonts.size.small};
  padding: 10px 16px;
  text-align: left;

  width: 100%;
  border: none;
  background-color: transparent;
  cursor: pointer;

  :hover {
    background-color: ${({ theme }) => theme.old.colors.gray[800]};
  }
`